//
//
//
//
//
//
//
//
//

import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'
import { faSync } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'EscrowBalance',
  mixins: [AxiosErrorHandler],
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      refreshing: false
    }
  },
  computed: {
    /**
     * Can current user refresh balance
     * @returns {Boolean}
     */
    canRefresh () {
      const currentRole = this.$store.getters['user/getActiveRoleData']
      return currentRole && currentRole?.id === this.task?.postedBy
    },

    /**
     * Refresh icon
     * @returns {IconDefinition}
     */
    refreshIcon () {
      return faSync
    },

    /**
     * Get balance without fee, only 5 decimal places
     * @returns {string}
     */
    balance () {
      return this.task.escrowBalanceFormatted
    }
  },
  methods: {
    async refreshEscrow () {
      try {
        this.refreshing = true
        await this.$store.dispatch('tasks/checkTaskEscrowBalance', this.task.id)
        this.refreshing = false
      } catch (err) {
        this.refreshing = false
        await this.handleError(err)
      }
    }
  }
}
